import { api_configuration } from "../../common";
import api_gui_model = api_configuration.libraries.gui_definition_lib.types.gui_model.alan_api;
import client_request_decorator = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_request.alan_api;
import SubscriptionBuilder from "./SubscriptionBuilder";

function createProperties(mapping: api_gui_model.Cduplication_node_mapping, builder: SubscriptionBuilder): void {
	mapping.properties.properties.forEach(function ($) {
		const property_name = $.key.entry;
		$.properties.type.switch({
			collection: function (collection_type) {
				const gui_collection = collection_type.inferences.collection();
				const collection_builder = builder.collection_entries(property_name);

				switch (gui_collection.properties.duplication_mapping.state.name) {
					case "from current context": {
						const from_current_context_duplication_mapping = gui_collection.properties.duplication_mapping.state.node;
						createProperties(from_current_context_duplication_mapping.properties.mapping, collection_builder);
						break;
					}
					case "none": {
						break;
					}
				}
			},
			file: function () {
				builder.file(property_name);
			},
			group: function ($) {
				createProperties($.properties.mapping, builder.group(property_name));
			},
			number: function () {
				builder.number(property_name);
			},
			"state group": function ($) {
				$.properties.states.forEach(function ($) {
					createProperties(
						$.properties.mapping,
						builder.state(
							property_name,
							$.key.ref.key.ref.key,
							$.parent.inferences.state_group().inferences.state_group()
						)
					);
				});
			},
			text: function () {
				builder.text(property_name);
			},
		});
	});
}
export default function (
	mapping: api_gui_model.Cduplication_node_mapping,
	id_path: client_request_decorator.Tid_path__client_request
): client_request_decorator.Tsubscription {
	const builder = SubscriptionBuilder.create();
	createProperties(mapping, builder);
	return {
		"context node": id_path,
		"mutation permissions": ["ignore", {}],
		"node subscription": { attributes: builder.properties },
	};
}
